
//This script gen the primary components like cards tables forms to use in pages in the app
//Crear PAUL
const card=(content0,content1,row0,row1)=>{
   
    return (
  
          <div className="card" >
          <div className="container" >
              <section className={row0}>
  
                  {content0}
              </section>
  
              <section className={row1}>
                  
                  {content1}
              </section>
  
              
          </div>
          </div>
      );
  
  
  }
const container=(content0,row0)=>{
    return (
          <div className="item" >
              <section className={row0}>
                    {content0}
              </section>
          </div>
      );
  }

  

  export {card,container};